import aboutImage from "../images/about-salon.png";

export default function About() {
  return (
    <section
      id="o-nas"
      className="py-20 px-4 bg-gradient-to-b from-amber-50/30 to-white"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="w-full h-[600px] rounded-3xl overflow-hidden shadow-2xl">
              <img
                src={aboutImage}
                alt="O našom salóne"
                loading="lazy"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-amber-700 rounded-3xl -z-10"></div>
          </div>

          <div>
            <h2 className="text-4xl text-center md:text-5xl font-bold text-gray-900 mb-6">
              O našom salóne
            </h2>

            <p className="text-lg text-center text-gray-700 leading-relaxed mb-6">
              Kadernícky salón Katka je miestom, kde sa stretáva profesionalita s
              príjemnou atmosférou. S viac ako 15-ročnými skúsenosťami v oblasti
              kaderníckeho umenia vám ponúkame služby na najvyššej úrovni.
            </p>

            <p className="text-lg text-center text-gray-700 leading-relaxed mb-6">
              Naším cieľom je nielen vytvoriť krásny účes, ale aj poskytnúť vám
              chvíle relaxu a pohody. Každému klientovi venujeme individuálnu
              pozornosť a snažíme sa pochopiť jeho predstavy a potreby.
            </p>

            <p className="text-lg text-center text-gray-700 leading-relaxed mb-8">
              Používame výhradne kvalitné profesionálne produkty, ktoré šetria
              vaše vlasy a zároveň zabezpečujú dlhotrvajúci výsledok. Neustále sa
              vzdelávame a sledujeme najnovšie trendy, aby sme vám mohli ponúknuť
              to najlepšie.
            </p>

            <div className="grid grid-cols-2 gap-6">
              <div className="bg-white rounded-2xl p-6 shadow-sm border border-amber-100/50">
                <div className="text-4xl font-bold text-amber-700 mb-2">
                  15+
                </div>
                <div className="text-gray-600 font-medium">
                  Rokov skúseností
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-sm border border-amber-100/50">
                <div className="text-4xl font-bold text-amber-700 mb-2">
                  2000+
                </div>
                <div className="text-gray-600 font-medium">
                  Spokojných klientov
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
